import { render } from "./App.vue?vue&type=template&id=bd71fdc0&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=bd71fdc0&lang=scss"

import exportComponent from "C:\\Users\\miauerka\\web-projects\\mimafi-project\\mimawebapp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__